module.exports = __webpack_public_path__ + "static/UI pattern 4-a41196eeab7e337a01c4e10ed35a0659.png";